exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ArticlePage__root___9PZBg {\n  max-width: 300px;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "ArticlePage__root___9PZBg"
};